export default __webpack_public_path__ + "static/media/onboardingAside.b3546514.png";